<template>
  <div class="animated fadeIn">
      <div class="d-flex flex-wrap align-items-center">
        <div class="mr-auto mb7">
          <label class="col-form-label font_20">
            WMDS
          </label>
        </div>
      </div>
      <b-row v-if="!is_main">
        <b-col sm="6">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10" />
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='name';so.skt='name'">name</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='fqdn';so.skt='host'">host</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <!-- <b-btn variant="outline-secondary"><i class="fa fa-search-plus"></i></b-btn> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="reg_card">
        <div class="reg_card_body">
          <div class="table-responsive">
            <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요." :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
              <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
              <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
              <template slot="action" slot-scope="row">{{row.item.action ? (codes.agent_forgery[row.item.action] || 'Changed') : '-'}}</template>
              <template slot="target" slot-scope="row">{{row.item.target ? row.item.target : '-'}}</template>
              <!-- <template slot="hash" slot-scope="row">
                <b-form-select size="sm" v-model="row.item.hash_selected">
                  <option :value="{ key : 0, value : row.item.hash[0]}">static</option>
                  <option :value="{ key : 1, value : row.item.hash[1]}">level 1</option>
                  <option :value="{ key : 2, value : row.item.hash[2]}">level 2</option>
                  <option :value="{ key : 3, value : row.item.hash[3]}">level 3</option>
                  <option :value="{ key : 4, value : row.item.hash[4]}">level 4</option>
                  <option :value="{ key : 5, value : row.item.hash[5]}">level 5</option>
                </b-form-select>
              </template>
              <template slot="depth" slot-scope="row">
                <b-form-input size="sm" v-model="row.item.hash_selected.key">{{row.item.hash_selected.key}}</b-form-input>
              </template>
              <template slot="is_apply" slot-scope="row">{{row.item.is_apply ? 'Confirm' : 'unidentified'}}</template>
              <template slot="func" slot-scope="row">
                <b-btn @click="save(row.item)" size="sm" variant="outline-success">Pass</b-btn>
                <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">More</b-btn>
              </template> -->
            </b-table>
          </div>
        </div>
      </div>
      <b-row class="mt30">
        <b-col class="pagination justify-content-center">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>